module.exports = __webpack_public_path__ + "static/img/MiniProgramQR.dca11a9e.jpg";